import { render, staticRenderFns } from "./ExpansionFooter.vue?vue&type=template&id=46cbed6a&"
import script from "./ExpansionFooter.vue?vue&type=script&lang=js&"
export * from "./ExpansionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports